import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IHealthInsuranceFundWithAddressDto, IHealthInsuranceFundWithAddressDtoQueryParams, IQueryResult } from 'gen/ApiClient';

export const HifsQueryContext = React.createContext<
	IQueryContext<IQueryResult<IHealthInsuranceFundWithAddressDto>, IHealthInsuranceFundWithAddressDtoQueryParams>
>(undefined as any);
